export default __webpack_public_path__ + "tab5_mobile581f71.mp4";